import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { GenericDocContainerModel } from "../../../../../../models/aggregates/generic_doc";
import { ApiResponseModel, ApiVisa } from "../../shared";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class GenericDocAllService extends BaseApiTemplateService<GenericDocContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "gen-doc";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "gen-doc";
    this.httpClient = http;
  }

  getByGenericCriteriaSnapshot(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<GenericDocContainerModel>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query/generic-snapshot/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<GenericDocContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getGenDocWithDoclinkList(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<GenericDocContainerModel>> {
     let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/doclink-list/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<GenericDocContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
